<template>
  <div class="flex w-full flex-col">
    <div class="bg-grey-15">
      <div class="grid xs:hidden">
        <div class="relative flex flex-row gap-x-4 px-4 py-2 2xs:pt-4">
          <ui-view-toggle id="animatedContainerShrink" class="transition-[right] duration-200 ease-linear" />
          <ui-toolbar-search
            id="animatedContainerExpand"
            class="absolute right-4 transition-[width] duration-200 ease-linear"
            :class="searchExpanded ? 'animate-searchToggle' : ''"
            @text-input:unfocused="searchExpanded = false"
            @text-input:focused="searchExpanded = true"
          />
        </div>
        <div class="flex flex-row justify-between px-4 py-2">
          <div class="flex flex-row gap-x-2">
            <ui-toolbar-map-mode-buttons />
            <ui-filters-button :set-toolbar-mode="ToolbarMode.Filters" />
          </div>
          <ui-toolbar-buttons />
        </div>
        <div v-show="hazardsStore.activeView === HazardView.Map && hazardsStore.mapMode !== MapMode.Default" class="px-4 pt-2">
          <ui-list-date-selector-tab />
        </div>
      </div>

      <div class="hidden xs:max-md:grid">
        <div class="flex flex-row gap-x-4 px-6 pb-2 pt-4">
          <ui-toolbar-search stretch />
        </div>
        <div class="flex flex-row justify-between px-6 pb-4 pt-2">
          <div class="flex flex-row gap-x-4">
            <ui-view-toggle />
            <ui-toolbar-map-mode-buttons />
            <ui-toolbar-filters />
          </div>
          <ui-toolbar-buttons />
        </div>
        <div
          v-show="hazardsStore.activeView === HazardView.Map && hazardsStore.mapMode !== MapMode.Default"
          class="flex flex-row px-4 pt-4"
        >
          <ui-list-date-selector-tab />
        </div>
      </div>

      <div class="hidden px-6 py-4 md:flex">
        <div class="flex flex-row items-center gap-4">
          <ui-view-toggle />
          <ui-toolbar-map-mode-buttons />
          <ui-toolbar-filters />
          <ui-toolbar-buttons />
        </div>
        <ui-toolbar-search class="ml-10" />
      </div>
    </div>
    <div class="xs:hidden"><ui-toolbar-fullscreen-dropdown /></div>
  </div>
</template>

<script setup lang="ts">
import { showBothHazardView } from '@/common/helpers/sizes';
import { ToolbarMode, useHazardsStore, HazardView, MapMode } from '@/features';
import { ref, watch, onMounted } from 'vue';

const hazardsStore = useHazardsStore();

const searchExpanded = ref(false);

const resize = (expand: boolean) => {
  const toolbar = document.getElementById('animatedContainerShrink');
  const search = document.getElementById('animatedContainerExpand');

  if (!toolbar || !search) return;

  if (expand) {
    toolbar.style.right = 'calc(50% + 1em)';
    search.style.width = 'calc(100% - 2em)';
  } else {
    toolbar.style.right = '0%';
    search.style.width = showBothHazardView.value ? '50%' : '60%';
  }
};

watch(searchExpanded, (value) => {
  resize(value);
});

onMounted(() => {
  resize(searchExpanded.value);
});
</script>
